export type CalculationType = 'zile_libere' | 'zile_calendaristice' | 'luni';

export const calculateRomanianDeadline = (startDateStr: string, duration: number, type: CalculationType = 'zile_libere'): Date => {
  const start = new Date(startDateStr);
  const target = new Date(start);

  if (type === 'zile_libere') {
    // Zile libere: nu se socotește nici ziua când începe, nici ziua când se împlinește
    target.setDate(target.getDate() + duration + 2); // Ziua 0 (start) + duration + Ziua finală
  } else if (type === 'zile_calendaristice') {
    target.setDate(target.getDate() + duration);
  } else if (type === 'luni') {
    target.setMonth(target.getMonth() + duration);
  }

  // Dacă termenul se împlinește într-o zi nelucrătoare, se prelungește până la sfârșitul primei zile de lucru următoare.
  const dayOfWeek = target.getDay();
  if (dayOfWeek === 6) target.setDate(target.getDate() + 2); // Sâmbătă -> Luni
  else if (dayOfWeek === 0) target.setDate(target.getDate() + 1); // Duminică -> Luni

  return target;
};

export const DEADLINE_PRESETS = [
  { id: 'apel_civil', label: 'Apel Civil (30 zile libere)', duration: 30, type: 'zile_libere' as CalculationType },
  { id: 'intampinare_civil', label: 'Întâmpinare Civil (25 zile libere)', duration: 25, type: 'zile_libere' as CalculationType },
  { id: 'recurs_civil', label: 'Recurs Civil (30 zile libere)', duration: 30, type: 'zile_libere' as CalculationType },
  { id: 'apel_penal', label: 'Apel Penal (10 zile)', duration: 10, type: 'zile_calendaristice' as CalculationType },
  { id: 'contestatie_executare', label: 'Contestație la executare (15 zile)', duration: 15, type: 'zile_calendaristice' as CalculationType },
  { id: 'plangere_contraventionala', label: 'Plângere contravențională (15 zile)', duration: 15, type: 'zile_calendaristice' as CalculationType },
  { id: '6_luni', label: '6 Luni', duration: 6, type: 'luni' as CalculationType },
];
